// import React from 'react';

// interface MetricCardProps {
//     icon: React.ReactNode;
//     value: string;
//     label: string;
//     change: number;
// }

// interface MetricCardsProps {
//     cards: MetricCardProps[];
// }

// const MetricCard: React.FC<MetricCardProps> = ({ icon, value, label, change }) => {
//     const isPositive = change >= 0;
//     const changeColor = isPositive ? '#FFFFFF' : '#EF4444';
//     const changeBgColor = isPositive ? '#DCFCE7' : '#FEE2E2';

//     return (
//         <div
//             style={{
//                 display: 'flex',
//                 flexDirection: 'column',
//                 alignItems: 'flex-start',
//                 justifyContent: 'flex-start',
//                 padding: '20px',
//                 backgroundColor: '#FFFFFF',
//                 borderRadius: '12px',
//                 boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
//                 border: '1px solid #E5E7EB',
//                 minWidth: '150px',
//                 fontFamily: '-apple-system, BlinkMacSystemFont, "Inter", Roboto, "Inter Neue", Arial, sans-serif'
//             }}
//         >
//             {/* Icon Container - Circular */}
//             <div
//                 style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     marginBottom: '12px',
//                     width: '40px',
//                     height: '40px',
//                     backgroundColor: '#E0E7FF',
//                     borderRadius: '50%',
//                     color: '#6366F1',
//                     flexShrink: 0
//                 }}
//             >
//                 {icon}
//             </div>

//             {/* Value - Large Bold Number */}
//             <div style={{ marginBottom: '4px' }}>
//                 <p
//                     style={{
//                         fontSize: '28px',
//                         fontWeight: '700',
//                         color: '#1F2937',
//                         margin: 0,
//                         lineHeight: '1.2'
//                     }}
//                 >
//                     {value}
//                 </p>
//             </div>

//             {/* Label - Gray Text */}
//             <div style={{ marginBottom: '12px', minHeight: '20px' }}>
//                 <p
//                     style={{
//                         fontSize: '12px',
//                         fontWeight: '500',
//                         color: 'black',
//                         margin: 0,
//                         lineHeight: '1.3'
//                     }}
//                 >
//                     {label}
//                 </p>
//             </div>

//             {/* Change Indicator - Pill Style */}
//             <div
//                 style={{
//                     display: 'inline-flex',
//                     alignItems: 'center',
//                     gap: '4px',
//                     padding: '4px 8px',
//                     backgroundColor: changeBgColor,
//                     borderRadius: '4px'
//                 }}
//             >
//                 <span
//                     style={{
//                         fontSize: '11px',
//                         fontWeight: '700',
//                         color: changeColor,
//                         letterSpacing: '0.5px'
//                     }}
//                 >
//                     {isPositive ? '' : ''}{Math.abs(change).toFixed(2)}%
//                 </span>
//             </div>
//         </div>
//     );
// };

// const MetricCards: React.FC<MetricCardsProps> = ({ cards }) => {
//     return (
//         <div
//             style={{
//                 display: 'flex',
//                 gap: '12px',
//                 overflowX: 'auto',
//                 paddingBottom: '4px',
//                 width: '100%',
//                 scrollBehavior: 'smooth'
//             }}
//         >
//             {cards.map((card, index) => (
//                 <MetricCard
//                     key={index}
//                     icon={card.icon}
//                     value={card.value}
//                     label={card.label}
//                     change={card.change}
//                 />
//             ))}
//         </div>
//     );
// };

// export default MetricCards;


// // Icon COMPONENTS - No external library needed
// export const ProjectsIcon = () => (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//         <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
//     </svg>
// );

// export const ChartIcon = () => (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//         <line x1="12" y1="5" x2="12" y2="19" />
//         <polyline points="19 12 12 19 5 12" />
//     </svg>
// );

// export const StockIcon = () => (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//         <circle cx="12" cy="12" r="1" />
//         <circle cx="19" cy="12" r="1" />
//         <circle cx="5" cy="12" r="1" />
//         <path d="M12 5v14M5 12h14" />
//     </svg>
// );

// export const LocationIcon = () => (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//         <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
//         <circle cx="12" cy="10" r="3" />
//     </svg>
// );

// export const PercentIcon = () => (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//         <circle cx="7" cy="7" r="2" />
//         <circle cx="17" cy="17" r="2" />
//         <line x1="9" y1="5" x2="15" y2="19" />
//     </svg>
// );

// export const SaveIcon = () => (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//         <circle cx="12" cy="12" r="1" />
//         <path d="M12 1v6m0 6v6" />
//         <path d="M4.22 4.22l4.24 4.24m5.08 5.08l4.24 4.24" />
//         <path d="M1 12h6m6 0h6" />
//         <path d="M4.22 19.78l4.24-4.24m5.08-5.08l4.24-4.24" />
//     </svg>
// );


// // USAGE EXAMPLE:
// export function MetricCardsExample() {
//     return (
//         <div style={{ backgroundColor: '#F9FAFB', padding: '32px', minHeight: '100vh' }}>
//             <h1 style={{ fontSize: '24px', fontWeight: 'bold', color: '#111827', marginBottom: '24px' }}>
//                 Dashboard Metrics
//             </h1>

//             <MetricCards
//                 cards={[
//                     {
//                         icon: <ProjectsIcon />,
//                         value: '327',
//                         label: 'Projects',
//                         change: 2.1
//                     },
//                     {
//                         icon: <ChartIcon />,
//                         value: '27.5M',
//                         label: 'Stock Qty',
//                         change: 2.1
//                     },
//                     {
//                         icon: <StockIcon />,
//                         value: '149M',
//                         label: 'Stock Value',
//                         change: -0.47
//                     },
//                     {
//                         icon: <LocationIcon />,
//                         value: '89M',
//                         label: 'C APEX',
//                         change: 2.1
//                     },
//                     {
//                         icon: <PercentIcon />,
//                         value: '72.4%',
//                         label: 'OPEX',
//                         change: -0.647
//                     },
//                     {
//                         icon: <SaveIcon />,
//                         value: '106M',
//                         label: 'Saving',
//                         change: 2.1
//                     }
//                 ]}
//             />


//         </div>
//     );
// }


import React from 'react';

interface MetricCardProps {
    icon: React.ReactNode;
    value: string;
    label: string;
    change?: number;
}

interface MetricCardsProps {
    cards: MetricCardProps[];
}

const MetricCard: React.FC<MetricCardProps> = ({ icon, value, label, change }) => {
    const isPositive = change !== undefined ? change >= 0 : true;
    const changeColor = isPositive ? '#FFFFFF' : '#EF4444';
    const changeBgColor = isPositive ? '#DCFCE7' : '#FEE2E2';

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                padding: '20px',
                backgroundColor: '#FFFFFF',
                borderRadius: '12px',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
                border: '1px solid #E5E7EB',
                minWidth: '150px',
                fontFamily: '-apple-system, BlinkMacSystemFont, "Inter", Roboto, "Inter Neue", Arial, sans-serif'
            }}
        >
            {/* Icon Container - Circular */}
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '12px',
                    width: '40px',
                    height: '40px',
                    backgroundColor: '#E0E7FF',
                    borderRadius: '50%',
                    color: '#6366F1',
                    flexShrink: 0
                }}
            >
                {icon}
            </div>

            {/* Value - Large Bold Number */}
            <div style={{ marginBottom: '4px' }}>
                <p
                    style={{
                        fontSize: '28px',
                        fontWeight: '700',
                        color: '#1F2937',
                        margin: 0,
                        lineHeight: '1.2'
                    }}
                >
                    {value}
                </p>
            </div>

            {/* Label - Gray Text */}
            <div style={{ marginBottom: '12px', minHeight: '20px' }}>
                <p
                    style={{
                        fontSize: '12px',
                        fontWeight: '500',
                        color: 'black',
                        margin: 0,
                        lineHeight: '1.3'
                    }}
                >
                    {label}
                </p>
            </div>

            {/* Change Indicator - Pill Style - Only shown if change is provided */}
            {change !== undefined && (
                <div
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '4px',
                        padding: '4px 8px',
                        backgroundColor: changeBgColor,
                        borderRadius: '4px'
                    }}
                >
                    <span
                        style={{
                            fontSize: '11px',
                            fontWeight: '700',
                            color: changeColor,
                            letterSpacing: '0.5px'
                        }}
                    >
                        {isPositive ? '' : ''}{Math.abs(change).toFixed(2)}%
                    </span>
                </div>
            )}
        </div>
    );
};

const MetricCards: React.FC<MetricCardsProps> = ({ cards }) => {
    return (
        <div
            style={{
                display: 'flex',
                gap: '12px',
                overflowX: 'auto',
                paddingBottom: '4px',
                width: '100%',
                scrollBehavior: 'smooth'
            }}
        >
            {cards.map((card, index) => (
                <MetricCard
                    key={index}
                    icon={card.icon}
                    value={card.value}
                    label={card.label}
                    change={card.change}
                />
            ))}
        </div>
    );
};

export default MetricCards;


// Icon COMPONENTS - No external library needed
export const ProjectsIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
    </svg>
);

export const ChartIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="5" x2="12" y2="19" />
        <polyline points="19 12 12 19 5 12" />
    </svg>
);

export const StockIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="1" />
        <circle cx="19" cy="12" r="1" />
        <circle cx="5" cy="12" r="1" />
        <path d="M12 5v14M5 12h14" />
    </svg>
);

export const LocationIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
    </svg>
);

export const PercentIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="7" cy="7" r="2" />
        <circle cx="17" cy="17" r="2" />
        <line x1="9" y1="5" x2="15" y2="19" />
    </svg>
);

export const SaveIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="1" />
        <path d="M12 1v6m0 6v6" />
        <path d="M4.22 4.22l4.24 4.24m5.08 5.08l4.24 4.24" />
        <path d="M1 12h6m6 0h6" />
        <path d="M4.22 19.78l4.24-4.24m5.08-5.08l4.24-4.24" />
    </svg>
);


// USAGE EXAMPLE:
export function MetricCardsExample() {
    return (
        <div style={{ backgroundColor: '#F9FAFB', padding: '32px', minHeight: '100vh' }}>
            <h1 style={{ fontSize: '24px', fontWeight: 'bold', color: '#111827', marginBottom: '24px' }}>
                Dashboard Metrics
            </h1>

            <MetricCards
                cards={[
                    {
                        icon: <ProjectsIcon />,
                        value: '327',
                        label: 'Projects',
                        change: 2.1
                    },
                    {
                        icon: <ChartIcon />,
                        value: '27.5M',
                        label: 'Stock Qty',
                        change: 2.1
                    },
                    {
                        icon: <StockIcon />,
                        value: '149M',
                        label: 'Stock Value',
                        change: -0.47
                    },
                    {
                        icon: <LocationIcon />,
                        value: '89M',
                        label: 'C APEX',
                        change: 2.1
                    },
                    {
                        icon: <PercentIcon />,
                        value: '72.4%',
                        label: 'OPEX',
                        change: -0.647
                    },
                    {
                        icon: <SaveIcon />,
                        value: '106M',
                        label: 'Saving',
                        change: 2.1
                    },
                    // Example card without change indicator
                    {
                        icon: <ProjectsIcon />,
                        value: '50',
                        label: 'New Projects'
                        // No change prop - indicator won't be shown
                    }
                ]}
            />


        </div>
    );
}
